module.exports = __webpack_public_path__ + "static/media/23117016_1638423929566125_7469095476320360791_o-thumb.680c14bc.jpg";